export default function Flourish({ src }: { src: string }): JSX.Element {
  return (
    <iframe
      src={`https://flo.uri.sh/${src}/embed`}
      title="Interactive or visual content"
      className="flourish-embed-iframe"
      style={{ width: "100%", height: "600px", border: 0 }}
      sandbox="allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
    ></iframe>
  );
}
